import { render, staticRenderFns } from "./StepReviewIssues.vue?vue&type=template&id=380b45a1"
import script from "./StepReviewIssues.vue?vue&type=script&lang=js"
export * from "./StepReviewIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports